export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderError@2x.png";